import { NavItem } from '@components/Nav/navItems';
import {
  corporate_landing_path,
  events_path,
  help_path,
  partners_list_path,
  pro_path,
  static_index_path,
  static_payment_policy_path,
  static_privacy_path,
  static_terms_path,
} from '@routes';

export const MAIN_LINK_ITEMS: NavItem[] = [
  { href: static_index_path(), name: 'About' },
  { href: pro_path(), name: 'Pro' },
  { href: events_path(), name: 'Events' },
  { href: partners_list_path(), name: 'Brand Partnerships' },
  { href: corporate_landing_path(), name: 'Group Subscriptions' },
];

export const MORE_LINK_ITEMS: NavItem[] = [
  {
    name: 'Terms',
    href: static_terms_path(),
  },
  {
    name: 'Privacy',
    href: static_privacy_path(),
  },
  {
    name: 'Payment Policy',
    href: static_payment_policy_path(),
  },
  {
    name: 'Help & Support',
    href: help_path(),
  },
];
